import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

@Component({
  selector: "app-kpi-rented-objects",
  templateUrl: "./kpi-rented-objects.component.html",
  styleUrls: ["./kpi-rented-objects.component.scss"],
})
export class KpiRentedObjectsComponent {
  @Input() resources$: Observable<any>;

  constructor(private router: Router) {}

  navigateToObject(eaOid: string, event: Event): void {
    event.preventDefault();
    this.router.navigate([
      "/crm",
      {
        outlets: {
          primary: ["showings", eaOid],
          sidebar: null,
          modal: [],
        },
      },
    ]);
  }
}
